module.exports = __webpack_public_path__ + "static/media/blackberry.ead509ae.svg";